<!-- eslint-disable vue/no-v-html -->
<template>
  <zm-dialog
    v-if="visible"
    :class="['addon-modal', { 'addon-modal__mobile': isMobile }]"
    :width="DIALOG_WIDTH"
    visible
    append-to-body
    lock-scroll
  >
    <youtube-player v-if="!isMobile && config.videoOptions" v-bind="config.videoOptions" />
    <div class="addon-modal__container addon-modal-learn-more__container">
      <zm-button data-testid="checkout-button-30" type="link" class="close-btn" aria-label="close" @click="handleCloseDialog">
        <img :src="closeIcon" class="addon-modal__container-close" />
      </zm-button>
      <div class="addon-modal__container-header">
        <img :src="config.icon" class="addon-modal__container-header__logo" />
        <div class="addon-modal__container-header__title">
          <span>{{ $t(config.title) }}</span>
        </div>
      </div>
      <div class="addon-modal__container-tip">
        {{ $t(config.featuresTip) }}
      </div>
      <div class="addon-modal__container-body">
        <common-add-content :config="config" @add="$emit('add', $event)" />
        <div class="addon-modal__container-body__intro">
          <div v-for="item in config.introList" :key="item.label" class="addon-modal__container-body__intro-item">
            <img :src="checkIcon" />
            <div>
              {{ $t(item.label) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </zm-dialog>
</template>
<script>
import YoutubePlayer from './youtube-player.vue'
import CommonAddContent from './common-add-content.vue'
import closeIcon from '@/assets/plans/close.svg';
import checkIcon from '@/assets/plans/check.svg';

export default {
  name: 'AddOnLearnMoreDialog',
  components: { CommonAddContent, YoutubePlayer },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    config: {
      required: true
    }
  },
  data() {
    return {
      closeIcon: closeIcon,
      checkIcon: checkIcon
    }
  },
  computed: {
    DIALOG_WIDTH() {
      return this.isMobile ? '' : '1300px'
    },
    isMobile(){
      return this.$context.is.mobile || this.$context.is.tablet
    }
  },
  methods: {
    handleCloseDialog() {
      this.$emit('updateVisible', false);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@zoom/billing-responsive/styles/responsive.scss';
.addon-modal {
  --dialog-bg-pc-w: 800px;
  --spacing-lg: 32px;
  --spacing-sm: 16px;
  --spacing-xs: 8px;
  --spacing-xxs: 4px;
  --text-fz: 16px;
  --btn-width: fit-content;
  --prefix-slot-width: 100%;
  --dialog-h: 600px;
  @import './common-variables.scss';

  &__container {
    flex: 1;
    max-width: calc(100% - var(--dialog-bg-pc-w));
    position: relative;
    padding: 32px;
    overflow-y: auto;

    @include media(desktop) {
      max-height: 620px;
    }

    &-close {
      @include style(svgIconSize(16px));
    }

    &-header {
      max-width: calc(100% - 16px - 4px);
      display: flex;
      align-items: center;
      justify-content: flex-start;

      &__logo {
        width: 44px;
        height: 44px;
        margin-right: 16px;
      }

      &__tag {
        display: inline-block;
        font-size: 14px;
        line-height: 20px;
        color: #fff;
        border-radius: 20px;
        font-weight: 500;
        padding: 0 8px;
        margin-left: 8px;
        background: linear-gradient(96.59deg, #493ab7 10.36%, #cf4b0a 89.64%);
        background: -o-linear-gradient(96.59deg, #493ab7 10.36%, #cf4b0a 89.64%);
        vertical-align: middle;
      }

      &__title {
        margin-right: 8px;
        color: #00053d;
        font-size: 22px;
        font-weight: 700;
        line-height: 1.2;
        position: relative;

        @include media(mini-tablet, tablet) {
          span:first-child {
            display: inline-block;
          }
          .required-tip-oth {
            position: static;
            margin-top: 4px;
          }
        }
      }
    }

    &-tip {
      margin: 16px 0;
      line-height: 1.5;
      color: #666487;
      font-size: 16px;
    }

    &-body {
      & > div:last-child {
        margin-bottom: 0;
      }
      .addon-modal__bg-mobile {
        width: 100%;
        margin-bottom: 16px;
      }
    }

    .close-btn {
      position: absolute;
      min-width: unset;
      padding: 0;
      top: calc(32px - 16px / 2);
      right: calc(32px - 16px / 2);
    }
  }

  ::v-deep .zm-dialog {
    padding: 0;
    border-radius: 8px;
    border: 0;
    overflow: hidden;

    &__header {
      display: none;
      padding: 0;
    }

    &__body {
      width: 100%;
      min-height: var(--dialog-h);
      display: flex;
    }
  }

  &__mobile {
    @include style($mobile-styles);
  }

  @include media(mobile, mini-tablet) {
    @include style($mobile-styles);
  }

  .addon-modal__container-body__intro {
    &-item {
      display: flex;
      align-items: baseline;
      justify-content: flex-start;
      line-height: 1.5;
      color: #00053d;
      font-size: 16px;
      font-weight: 400;
      letter-spacing: 0;
      margin-bottom: 8px;

      > img {
        margin-right: 3px;
        width: 12px;
        height: 12px;
        flex-grow: 0;
        flex-shrink: 0;
      }
    }
  }

}
</style>
